<template>
  <div v-if="rate.doctor">
    {{ tStatic('Лечащий врач') }}:
    <a
      class="ui-text primary--text"
      :href="doctorUrl"
      :title="doctorName"
    >
      {{ doctorName }}
    </a>
    <div
      v-if="specialityName"
      class="d-flex text-body-2 text--text gc-1 mt-1"
    >
      <span>{{ tStatic('Специальность') }}:</span>
      <span>{{ specialityName }}</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import type { ContextStore } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/index/types'
import useContextStore from 'src/store/useContextStore'
import useURLStore from 'src/store/useURLStore'
import tDynamic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tDynamic'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import type { Lpu } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_types'
import type { Rate } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/types'

const props = defineProps<{
  rate: Rate
  lpu: Lpu
}>()

const { urlLang }: ContextStore = useContextStore()
const { reverseFullL10N } = useURLStore()
const doctorName = computed(() => tDynamic(props.rate.doctor, 'fio_short'))
const specialityName = computed(() => tDynamic(props.rate.speciality, 'name'))
const doctorUrl = computed(() => {
  const translit = props.rate.doctor_in_current_town?.translit || props.rate.doctor?.translit

  if (!translit) {
    return undefined
  }

  return reverseFullL10N({
    name: 'doctor',
    args: {
      language: urlLang,
      town_translit: props.lpu.town.translit,
      doctor_translit: translit,
    },
  })
})
</script>
